import { render, staticRenderFns } from "./AnimateNumber.vue?vue&type=template&id=883cc848&"
import script from "./AnimateNumber.vue?vue&type=script&lang=js&"
export * from "./AnimateNumber.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ploi/www.continental-holdings.com/web/app/themes/chc-wp-theme/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('883cc848')) {
      api.createRecord('883cc848', component.options)
    } else {
      api.reload('883cc848', component.options)
    }
    module.hot.accept("./AnimateNumber.vue?vue&type=template&id=883cc848&", function () {
      api.rerender('883cc848', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/scripts/components/AnimateNumber.vue"
export default component.exports